import PropTypes from 'prop-types';
import { Button, Loader, Menu } from '@mantine/core';
import {
  IconDownload,
  IconFileTypePdf,
  IconFileTypeXls,
  IconMail,
} from '@tabler/icons-react';
import prepareTranslate from '@/helpers/dictionary';
import { useDisclosure } from '@mantine/hooks';
import { useState } from 'react';
import ModalEmailExport from '@/components/Table/Export/EmailModal/index';
import { downloadFile } from '@/helpers/download';

const TYPES = {
  pdf: {
    title: 'Pdf',
    icon: <IconFileTypePdf />,
  },
  excel: {
    title: 'Excel',
    icon: <IconFileTypeXls />,
  },
  email: {
    title: 'Email',
    icon: <IconMail />,
  },
};

const Export = (props) => {
  const {
    onExportSubmit = () => {},
    options,
    tableLoading,
    columns,
    rowsData,
    emailtemplateId,
  } = props;

  const [filePreview, setFilePreview] = useState([]);
  const [loading, { open, close }] = useDisclosure(false);
  const [emailModalOpen, setEmailModalOpen] = useState(false);

  const t = prepareTranslate();

  const clickOnFile = async (e) => {
    const { currentTarget } = e;
    const { option } = currentTarget.dataset;

    if (option === 'email') {
      open();
      const { fileData, fileTitle } = await onExportSubmit('excel', {});

      close();
      setEmailModalOpen(true);
      setFilePreview([{
        fileData,
        name: fileTitle,
      }]);
      return;
    }

    const dataToExport = {
      options: [option],
    };

    open();
    const { fileData, fileTitle } = await onExportSubmit(option, dataToExport);
    downloadFile(fileData, fileTitle);
    close();
  };

  const exportOptions = options || ['pdf', 'excel'];

  const items = exportOptions.map((option) => {
    const item = TYPES[option];

    if (!item) {
      return null;
    }

    const { title, icon } = item;

    return (
      <Menu.Item
        key={option}
        data-option={option}
        onClick={clickOnFile}
        leftSection={icon}
      >
        {title}
      </Menu.Item>
    );
  });

  const leftSection = loading ? (
    <Loader size={15}/>
  ) : (
    <IconDownload stroke="1" />
  );

  const isDisabled = tableLoading || loading;

  return (
      <Menu shadow="md">
        <ModalEmailExport
        columns={columns}
        opened={emailModalOpen}
        onClose={() => setEmailModalOpen(false)}
        rowsData={rowsData}
        onSend={async ({ email, subject }) => {
          const exportPayload = {
            email,
            subject,
            options: ['email'],
          };
          await onExportSubmit('email', exportPayload);
          close();
        }}
        filePreview={filePreview}
        emailtemplateId={emailtemplateId}
      />
        <Menu.Target>
        <Button
          color="gray"
          size="xs"
          variant="outline"
          leftSection={leftSection}
          disabled={isDisabled}
        >
          {t('components.export.action')}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{t('components.export.label')}</Menu.Label>
        {items}
      </Menu.Dropdown>
    </Menu>
  );
};

Export.propTypes = {
  options: PropTypes.array,
  onExportSubmit: PropTypes.func.isRequired,
  exportData: PropTypes.object.isRequired,
  tableLoading: PropTypes.bool,
  columns: PropTypes.array,
  rowsData: PropTypes.array,
  emailtemplateId: PropTypes.string,
};

export default Export;
